import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Box from '@mui/material/Box';

interface SessionExpiredDialogProps {
    open: boolean;
    onLogin: () => void;
}

const SessionExpiredDialog: React.FC<SessionExpiredDialogProps> = ({ open, onLogin }) => {
    return (
        <Dialog
            open={open}
            disableEscapeKeyDown
            aria-labelledby="session-expired-dialog-title"
            PaperProps={{
                sx: {
                    backgroundColor: 'black',
                    color: '#fff',
                    borderRadius: '12px',
                    minWidth: 360,
                    textAlign: 'center',
                }
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.75)',
                    }
                }
            }}
        >
            <DialogTitle id="session-expired-dialog-title" sx={{ py: 1.5, backgroundColor: '#1a1a1a', borderBottom: '1px solid #333' }}>
                <Box display="flex" flexDirection="column" alignItems="center" gap={0.5}>
                    <ErrorOutlineIcon sx={{ fontSize: 36, color: '#ff9800' }} />
                    <Typography variant="h6" fontWeight={600} color="#fff">
                        Session Expired
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ pt: 2, backgroundColor: 'black !important' }}>
                <Typography variant="body1" color="#fff">
                    Your session has expired due to inactivity. Please log in again to continue.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 3, backgroundColor: 'black !important' }}>
                <Button
                    variant="contained"
                    onClick={onLogin}
                    sx={{
                        backgroundColor: '#00677f !important',
                        color: 'whitesmoke !important',
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 4,
                        borderRadius: '6px',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 103, 127, 0.8) !important',
                        }
                    }}
                >
                    Login
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionExpiredDialog;
